import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { tgIcon } from '../../../assets';

import { TRootState } from '../../../store/store';
import { transport } from '../../../utils/constants';
import { getColor, getToken, setAvas } from '../../../utils/helper';
import Ava from '../Ava/Ava';

import './SignUp.scss';
import { Account_Info } from '../../../generated/mlmbox/types/account';
import { NetworkClient } from '../../../generated/mlmbox/client/network/network.client';
import { Status_Referral } from '../../../generated/mlmbox/types/status';
import Button from '../../Button/Button';

const SignUp: FC<{ closeFunc: Function; setAddRef: Function }> = ({ closeFunc, setAddRef }) => {
    const auth = useSelector((state: TRootState) => state.auth.value);
    const referral = useSelector((state: TRootState) => state.user.value.info.referral);
    const [refferalShortInfo, setReferralShortImfo] = useState<Account_Info>();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const accountClient = new NetworkClient(transport);

    useEffect(() => {
        accountClient
            .memberGet({ uniqueField: { accountId: referral.id, oneofKind: 'accountId' } }, { meta: { authorization: getToken() } })
            .then(async ({ response, status: { code } }) => {
                if (code === 'OK') {
                    const info = response;
                    if (info) await setAvas([info]);
                    setReferralShortImfo(response);
                }
            });
    }, []);

    function closing() {
        closeFunc();
    }
    return (
        <div className="sign-up">
            {refferalShortInfo && (
                <>
                    <div className="sign-up__header">
                        <span>🎉</span>
                        <h1>{t('modals.signup.header.title')}</h1>
                        <p>{t('modals.signup.header.text')}</p>
                    </div>
                    {auth.referralStatus === Status_Referral.EXISTS ? (
                        <div className="sign-up__referral">
                            <Ava
                                width="140px"
                                height="140"
                                collectionId={refferalShortInfo.profile?.ava?.collectionId}
                                entityId={refferalShortInfo.profile?.ava?.entityId}
                                borderColor={getColor(refferalShortInfo.relationship)}
                            />
                            <h1>{refferalShortInfo?.profile?.firstName + ' ' + refferalShortInfo?.profile?.lastName}</h1>
                            <p>{t('modals.signup.referral.success')}</p>
                        </div>
                    ) : (
                        <div className="sign-up__referral">
                            <span>😕</span>

                            <p>{t('modals.signup.referral.error')}</p>
                        </div>
                    )}
                    {auth.referralStatus === Status_Referral.EXISTS ? (
                        <div className="sign-up__btns">
                            {refferalShortInfo.profile?.telegram?.username && (
                                <Button
                                    title={t('btns.send_to_tg')}
                                    icon={tgIcon}
                                    onClick={() => {
                                        closing();
                                        window.Telegram.WebApp.openTelegramLink(`https://t.me/${refferalShortInfo.profile?.telegram?.username}`);
                                    }}
                                />
                            )}

                            <Button
                                title={t('btns.go_to_profile')}
                                onClick={() => {
                                    closing();
                                    navigate('/profile');
                                }}
                            />
                        </div>
                    ) : (
                        <div className="sign-up__btns">
                            <Button
                                title={t('btns.skip')}
                                onClick={() => {
                                    closing();
                                }}
                            />
                            <Button
                                title={t('btns.add_ref')}
                                onClick={() => {
                                    closing();
                                    setAddRef();
                                }}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default SignUp;
